import axios from "axios";

export default axios.create({
    baseURL: "https://reclu.ecoraapp.com/api/api", //https://app.ecoraapp.com:8094
    headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*"
    }
});